/**
 * An empty function which does nothing.
 */
export default function noop(): void {}
